import { client } from '@app/data/iron';

const GET_COUNTRIES = async ({ queryKey }) => {
  const [, { context, vertical }] = queryKey;
  const { data } = await client.get(`/api/shipping/countries`, {
    params: {
      format: 'ranked',
      context,
      productCategory: vertical,
    },
  });

  return data;
};

export default GET_COUNTRIES;
